exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errorPage{height:100%;width:100%;position:relative}.errorPage>div{position:absolute;color:#999;top:50%;font-size:.26rem;text-align:center;left:50%;margin-left:-1.75rem;margin-top:-1.75rem}.errorPage>div>img{width:3.5rem;margin-bottom:.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07692980","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/navigation/navigation.vue
// module id = Wiuq
// module chunks = 1